import { render, staticRenderFns } from "./ActionsDialog.vue?vue&type=template&id=444aa102&scoped=true&"
import script from "./ActionsDialog.vue?vue&type=script&lang=js&"
export * from "./ActionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActionsDialog.vue?vue&type=style&index=0&id=444aa102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444aa102",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon})
